module.exports = __webpack_public_path__ + "static/media/Female08.ca962ef0.jpg";